import React from 'react';
import { modalId } from '../common';
import ModalOptionContainer from '../containers/ModalOptionContainer';

const Modal = ({title, field, options, disabledOptions, blank_label}) => {
  let modalID = modalId(field.name);
  let types = field.types;
  let hasTypes = typeof types !== 'undefined';
  
  return (
    <div className="modal options" id={modalID} tabIndex="-1" role="dialog" aria-labelledby={title}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.13281 8L16 1.13281L14.8672 0L8 6.86719L1.13281 0L0 1.13281L6.86719 8L0 14.8672L1.13281 16L8 9.13281L14.8672 16L16 14.8672L9.13281 8Z" fill="#041604"/>
              </svg>
            </button>
            <h4 className="modal-title">{title}</h4>
          </div>
          <div className="modal-body">
            <section className={hasTypes ? 'finishes' : null}>
              {(!hasTypes && blank_label) ?
                <ModalOptionContainer key="blank" field={field} option={{displayName: field.blank_label, image: '', value: field.blank_label}} disabledOptions={disabledOptions} modalId={modalID} blank_label={blank_label} /> : null
              }

              {hasTypes ?
                Object.keys(types).map(function(type_slug) {
                  const finishes = options.filter( option => option.finish === type_slug);
                  
                  if (finishes.length === 0) {
                    return '';
                  }
                  
                  return (
                    <div key={type_slug + finishes[0].id} className={type_slug}>
                      <h3>{types[type_slug]}</h3>
                      <ul>
                        {finishes.map( finish => {
                          return [<li key={finish.id}><ModalOptionContainer key={finish.id} field={field} option={finish} disabledOptions={disabledOptions} modalId={modalID} /></li>, ' '];
                        })}
                      </ul>
                    </div>
                  );
                }) :
              
                options.map(function(option) {
                  return <ModalOptionContainer key={option.id} field={field} option={option} disabledOptions={disabledOptions} modalId={modalID} />;
                })
              }
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
